export default {
  isSure: '是否退出系统?',
  tips: '提示'
}
